// Components==============
import GridFiller from 'components/UI/GridFiller/GridFiller';
import React, { useContext } from 'react';
import { AssessmentContext } from '../Feedback';
import FeedbackItem from '../components/ReflectionItem/FeedbackItem';
import './Views.module.scss';
// =========================

export default function FeedbackView() {
  const { wrapperRef, groupedSparks } = useContext(AssessmentContext);

  return (
    <div styleName="wrapper" ref={wrapperRef}>
      {groupedSparks.map((skill) => (
        <div key={skill.id}>
          <FeedbackItem skill={skill} id={skill.id} />
        </div>
      ))}
      <GridFiller />
    </div>
  );
}
